// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.logo {\n\tmargin-bottom: 2em;\n\tmax-width: 280px;\n}\n", ""]);
// Exports
module.exports = exports;
